// This file was automatically generated by scripts/update-permissions.ts.
// Do not modify this file manually.

import type { Permissions } from './permissions';

export const ALL_PERMISSIONS = [
  'addAction',
  'addCorrection',
  'createAlert',
  'createApiKey',
  'createApplication',
  'createApplications',
  'createArchiveTransitionRule',
  'createArchivedImageAnalysis',
  'createArtifactRelationship',
  'createArtifactRelationships',
  'createAssets',
  'createImage',
  'createLicenseOverride',
  'createNotificationEndpointConfiguration',
  'createPolicy',
  'createRegistry',
  'createRepository',
  'createRoleMember',
  'createRuntimeInventory',
  'createScheduledQuery',
  'createSubscription',
  'createUser',
  'createVulnAnnotation',
  'deleteApiKey',
  'deleteApplication',
  'deleteApplications',
  'deleteArchiveTransitionRule',
  'deleteArchiveTransitionRuleHistory',
  'deleteArchivedImageAnalysis',
  'deleteArtifactRelationships',
  'deleteCorrection',
  'deleteEvents',
  'deleteImage',
  'deleteInventory',
  'deleteNotificationEndpointConfiguration',
  'deletePolicy',
  'deleteRegistry',
  'deleteRoleMember',
  'deleteScheduledQuery',
  'deleteScheduledQueryResult',
  'deleteSource',
  'deleteSubscription',
  'deleteUser',
  'deleteVulnAnnotation',
  'executeScheduledQuery',
  'getAccount',
  'getActions',
  'getAlert',
  'getApiKey',
  'getApplication',
  'getArchiveTransitionRule',
  'getArchiveTransitionRuleHistory',
  'getArchivedImageAnalysis',
  'getArtifactRelationshipDiff',
  'getCorrection',
  'getECSContainers',
  'getECSServices',
  'getECSTasks',
  'getEvent',
  'getImage',
  'getImageEvaluation',
  'getIntegration',
  'getKubernetesClusters',
  'getKubernetesContainers',
  'getKubernetesNamespaces',
  'getKubernetesNodes',
  'getKubernetesPods',
  'getKubernetesVulnerabilities',
  'getNotificationEndpointConfiguration',
  'getPolicy',
  'getRegistry',
  'getRole',
  'getRuntimeInventory',
  'getSource',
  'getSourceEvaluation',
  'getSubscription',
  'getVulnAnnotation',
  'importImage',
  'importSource',
  'listAccountUsersWithRoles',
  'listAccounts',
  'listAlerts',
  'listAllUsers',
  'listApiKeys',
  'listArchiveTransitionRules',
  'listArchivedImageAnalysis',
  'listArchives',
  'listArtifactRelationships',
  'listEvents',
  'listImages',
  'listIntegrations',
  'listLicenseOverrides',
  'listNotificationEndpointConfigurations',
  'listNotificationEndpoints',
  'listPolicies',
  'listRegistries',
  'listRoleMembers',
  'listRoles',
  'listRuntimeInventories',
  'listSources',
  'listSubscriptions',
  'listUsers',
  'listVulnAnnotations',
  'readApplications',
  'registerIntegration',
  'reportHealth',
  'selfAddCredential',
  'selfCreateApiKey',
  'selfDeleteApiKey',
  'selfDeleteCredential',
  'selfGetApiKey',
  'selfGetCredentials',
  'selfListApiKeys',
  'selfUpdateApiKey',
  'syncInventory',
  'updateAlert',
  'updateApiKey',
  'updateApplication',
  'updateApplications',
  'updateCorrection',
  'updateLicenseOverride',
  'updateNotificationEndpointConfiguration',
  'updatePolicy',
  'updateRegistry',
  'updateScheduledQuery',
  'updateSubscription',
  'updateUser',
  'updateVulnAnnotation',
  'viewReports',
] as const satisfies readonly (keyof Permissions)[];

export const ROLE_PERMISSIONS = {
  'account-user-admin': [
    'createApiKey',
    'createRoleMember',
    'createUser',
    'deleteApiKey',
    'deleteRoleMember',
    'deleteUser',
    'getAccount',
    'getApiKey',
    'getRole',
    'listAccountUsersWithRoles',
    'listApiKeys',
    'listRoleMembers',
    'listRoles',
    'listUsers',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'updateApiKey',
    'updateUser',
  ],
  'account-viewer': ['listAccounts'],
  'application-delete': ['deleteApplications'],
  'application-editor': [
    'createApplications',
    'createAssets',
    'updateApplications',
  ],
  'full-control': ['*'],
  'image-analyzer': [
    'createArtifactRelationships',
    'createImage',
    'createSubscription',
    'deleteSubscription',
    'getAccount',
    'getEvent',
    'getImage',
    'getImageEvaluation',
    'getSource',
    'getSourceEvaluation',
    'getSubscription',
    'getVulnAnnotation',
    'importImage',
    'importSource',
    'listArtifactRelationships',
    'listEvents',
    'listImages',
    'listSources',
    'listSubscriptions',
    'listVulnAnnotations',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'updateSubscription',
    'viewReports',
  ],
  'image-delete': [
    'deleteApplications',
    'deleteArchivedImageAnalysis',
    'deleteImage',
    'deleteSource',
    'listArchivedImageAnalysis',
    'listImages',
    'listSources',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
  ],
  'image-developer': [
    'getAccount',
    'getActions',
    'getAlert',
    'getApplication',
    'getArchiveTransitionRule',
    'getArchiveTransitionRuleHistory',
    'getArchivedImageAnalysis',
    'getCorrection',
    'getEvent',
    'getImage',
    'getImageEvaluation',
    'getNotificationEndpointConfiguration',
    'getPolicy',
    'getRegistry',
    'getSource',
    'getSourceEvaluation',
    'getSubscription',
    'getVulnAnnotation',
    'listAlerts',
    'listArchiveTransitionRules',
    'listArchivedImageAnalysis',
    'listArchives',
    'listArtifactRelationships',
    'listEvents',
    'listImages',
    'listNotificationEndpointConfigurations',
    'listNotificationEndpoints',
    'listPolicies',
    'listRegistries',
    'listSources',
    'listSubscriptions',
    'listVulnAnnotations',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
  ],
  'image-lifecycle': [
    'createArchiveTransitionRule',
    'createArchivedImageAnalysis',
    'deleteArchiveTransitionRule',
    'deleteArchiveTransitionRuleHistory',
    'deleteArchivedImageAnalysis',
    'getArchiveTransitionRule',
    'getArchiveTransitionRuleHistory',
    'getArchivedImageAnalysis',
    'listArchiveTransitionRules',
    'listArchivedImageAnalysis',
    'listArchives',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
  ],
  'inventory-agent': [
    'registerIntegration',
    'reportHealth',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'syncInventory',
  ],
  'license-override': [
    'createLicenseOverride',
    'listLicenseOverrides',
    'updateLicenseOverride',
  ],
  'policy-editor': [
    'createPolicy',
    'deletePolicy',
    'getAccount',
    'getCorrection',
    'getImage',
    'getImageEvaluation',
    'getPolicy',
    'getSource',
    'getSourceEvaluation',
    'getVulnAnnotation',
    'listImages',
    'listPolicies',
    'listSources',
    'listSubscriptions',
    'listVulnAnnotations',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'updatePolicy',
    'viewReports',
  ],
  'read-only': [
    'getAccount',
    'getActions',
    'getAlert',
    'getApplication',
    'getArchiveTransitionRule',
    'getArchiveTransitionRuleHistory',
    'getArchivedImageAnalysis',
    'getCorrection',
    'getECSContainers',
    'getECSServices',
    'getECSTasks',
    'getEvent',
    'getImage',
    'getImageEvaluation',
    'getIntegration',
    'getKubernetesClusters',
    'getKubernetesContainers',
    'getKubernetesNamespaces',
    'getKubernetesNodes',
    'getKubernetesPods',
    'getKubernetesVulnerabilities',
    'getNotificationEndpointConfiguration',
    'getPolicy',
    'getRegistry',
    'getRuntimeInventory',
    'getSource',
    'getSourceEvaluation',
    'getSubscription',
    'getVulnAnnotation',
    'listAlerts',
    'listArchiveTransitionRules',
    'listArchivedImageAnalysis',
    'listArchives',
    'listArtifactRelationships',
    'listEvents',
    'listImages',
    'listIntegrations',
    'listNotificationEndpointConfigurations',
    'listNotificationEndpoints',
    'listPolicies',
    'listRegistries',
    'listRuntimeInventories',
    'listSources',
    'listSubscriptions',
    'listVulnAnnotations',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'viewReports',
  ],
  'read-write': [
    'addAction',
    'addCorrection',
    'createAlert',
    'createApplication',
    'createApplications',
    'createArchiveTransitionRule',
    'createArchivedImageAnalysis',
    'createArtifactRelationship',
    'createAssets',
    'createImage',
    'createNotificationEndpointConfiguration',
    'createPolicy',
    'createRegistry',
    'createRepository',
    'createRuntimeInventory',
    'createScheduledQuery',
    'createSubscription',
    'deleteApplication',
    'deleteApplications',
    'deleteArchiveTransitionRule',
    'deleteArchivedImageAnalysis',
    'deleteArtifactRelationships',
    'deleteCorrection',
    'deleteEvents',
    'deleteImage',
    'deleteInventory',
    'deleteNotificationEndpointConfiguration',
    'deletePolicy',
    'deleteRegistry',
    'deleteScheduledQuery',
    'deleteScheduledQueryResult',
    'deleteSource',
    'deleteSubscription',
    'executeScheduledQuery',
    'getAccount',
    'getActions',
    'getAlert',
    'getApplication',
    'getArchiveTransitionRule',
    'getArchiveTransitionRuleHistory',
    'getArchivedImageAnalysis',
    'getArtifactRelationshipDiff',
    'getCorrection',
    'getECSContainers',
    'getECSServices',
    'getECSTasks',
    'getEvent',
    'getImage',
    'getImageEvaluation',
    'getIntegration',
    'getKubernetesClusters',
    'getKubernetesContainers',
    'getKubernetesNamespaces',
    'getKubernetesNodes',
    'getKubernetesPods',
    'getKubernetesVulnerabilities',
    'getNotificationEndpointConfiguration',
    'getPolicy',
    'getRegistry',
    'getRuntimeInventory',
    'getSource',
    'getSourceEvaluation',
    'getSubscription',
    'getVulnAnnotation',
    'importImage',
    'importSource',
    'listAlerts',
    'listArchiveTransitionRules',
    'listArchivedImageAnalysis',
    'listArchives',
    'listArtifactRelationships',
    'listEvents',
    'listImages',
    'listIntegrations',
    'listNotificationEndpointConfigurations',
    'listNotificationEndpoints',
    'listPolicies',
    'listRegistries',
    'listRuntimeInventories',
    'listSources',
    'listSubscriptions',
    'listVulnAnnotations',
    'readApplications',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'syncInventory',
    'updateAlert',
    'updateApplication',
    'updateApplications',
    'updateCorrection',
    'updateNotificationEndpointConfiguration',
    'updatePolicy',
    'updateRegistry',
    'updateScheduledQuery',
    'updateSubscription',
    'viewReports',
  ],
  'registry-editor': [
    'createRegistry',
    'deleteRegistry',
    'getRegistry',
    'listRegistries',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'updateRegistry',
  ],
  'repo-analyzer': [
    'createRepository',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
  ],
  'report-admin': [
    'createScheduledQuery',
    'deleteScheduledQuery',
    'deleteScheduledQueryResult',
    'executeScheduledQuery',
    'listImages',
    'selfAddCredential',
    'selfCreateApiKey',
    'selfDeleteApiKey',
    'selfDeleteCredential',
    'selfGetApiKey',
    'selfGetCredentials',
    'selfListApiKeys',
    'selfUpdateApiKey',
    'updateScheduledQuery',
    'viewReports',
  ],
  'system-admin': ['*'],
  'user-viewer': ['listAllUsers'],
  'vuln-annotator-editor': [
    'createVulnAnnotation',
    'deleteVulnAnnotation',
    'getVulnAnnotation',
    'listVulnAnnotations',
    'updateVulnAnnotation',
  ],
} as const satisfies Record<string, readonly (keyof Permissions)[]>;

export const SYSTEM_DOMAIN_ROLES = [
  'account-viewer',
  'license-override',
  'user-viewer',
] as const;
